import React, { Component } from "react";
import axios from "../../../axios";
import Alert from "react-s-alert";
import qs from "qs";
import DropdownView from "./DropdownView";
import ResetUjianModal from "../../../components/ResetUjianModal";

class Score extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dataSiswa: [],
            dataExport   : [],
            dataParticipant: [],
            exam_cat_id: 0,
            pageCount: 0,
            currentPage: 0,
            isLoading: false,
            isButtonLoading: false,
            isModalShow: false,
            modalEditShow:false,
            examId:"",
            nama:"",
            participant_id:""
        };

        this.handleChange = this.handleChange.bind(this);
        this.toggleModalEdit = this.toggleModalEdit.bind(this);

    }

    toggleModalEdit(e,f) {
        this.setState({
            entry_id : e,
            user_id: f,
            modalEditShow: !this.state.modalEditShow
        });
    }

    handleChange(event) {
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;

        const newState = {
            [name]: value
        }

        this.setState(
            newState,
            () => this.loadData()
        )
    }

    loadData() {
        this.setState({ isLoading: true });

        const params = qs.stringify({
            page: this.state.currentPage + 1,
            locale:"id",
            platform:"web",
            cari: this.state.nama,
            exam_id:this.props.match.params.exam_id,
            participant_id:this.state.participant_id
        });

        axios({
            method: "post",
            url: "ujian/siswa?" + params
        })

            .then(response => {
                const result = response.data;

                if (result.success === true) {
                    this.setState({
                        dataSiswa: result.data[0].sis,
                        isLoading: false
                    });
                } else {
                    Alert.error(result.message);
                    this.setState({ isLoading: false });
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ isLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });
    }

    loadDataParti(){
        this.setState({ isLoading: true });
        const params = qs.stringify({
            locale:"id",
            platform:"web",
            exam_id:this.props.match.params.exam_id
        });

        axios({
            method: "post",
            url: "exam/participant?" + params
        })
            .then(response => {
                const result = response.data;

                if (result.status === true) {
                    const dataParticipant = result.data.participant.map(item => ({
                        key: item.participant_id,
                        value: item.kelas_nama
                    }));

                    this.setState({
                        dataParticipant,
                        isLoading: false
                    });
                } else {
                    Alert.error(result.text);
                    this.setState({ isLoading: false });
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ isLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });
    }

    componentDidMount() {
        this.loadData();
        this.loadDataParti();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.nama !== this.state.nama) {
            this.loadData()
        }
    }

    render() {
        return (
            <div>
                <ResetUjianModal
                    modalHeaderText="Reset Ujian"
                    modalBodyText = "Anda yakin ingin mereset ujian ini?"
                    modalSubmitText="Reset Ujian"
                    user_id = {this.state.user_id}
                    entry_id = {this.state.entry_id}
                    toggleModalEdit={this.toggleModalEdit}
                    isShow={this.state.modalEditShow}
                />
                <div className="card" >
                    <div className="card-block">
                        <div className="col-md-12 form-group row">
                            <div className="col-md-6">
                                <DropdownView
                                    handleChange={this.handleChange}
                                    stateName="participant_id"
                                    label="Pilih Kelas Peserta"
                                    disabled={this.props.mode === 'Edit' ? true : false}
                                    items={this.state.dataParticipant}
                                    value={this.state.participant_id}
                                />
                            </div>
                            <div className="col-md-6">
                                <input
                                    name="nama"
                                    type="text"
                                    className="form-control"
                                    placeholder="Ketikkan Nama Pengguna..."
                                    value={this.state.nama}
                                    onChange={this.handleChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="card-header">Peserta</div>
                    <div className="card-block">
                        {this.state.isLoading ? (
                            "Memuat Data..."
                        ) : this.state.dataSiswa.length === 0 ? (
                            "Data Kosong..."
                        ) : (
                            <div>
                                <div className="card">
                                    <table className="table table-striped table-bordered animated fadeIn">
                                        <thead>
                                        <tr>
                                            <th>NAMA SISWA</th>
                                            <th>NIS</th>
                                            <th width={150} className="text-right">NILAI</th>
                                            <th width={150} className="text-right">Dijawab/Total Soal</th>
                                            <th width={100} className="text-right">STATUS</th>
                                            <th width={100} className="text-right">AKSI</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.dataSiswa.map(items => {
                                            return (
                                                <tr key={items.user_id}>

                                                    <td>{items.user_nama}</td>
                                                    <td>{items.siswa_nis}</td>
                                                    <td className="text-right">{items.nilai}</td>
                                                    <td className="text-right">{items.totJawab}/{items.totSoal}</td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className={`btn btn-sm ${
                                                                items.entry_status != null
                                                                    ? "btn-primary"
                                                                    : "btn-warning"
                                                                }`}

                                                        >
                                                            {items.entry_status != null ? items.entry_status : 'uncorections'}
                                                        </button>
                                                    </td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-danger"
                                                            onClick={() => {this.toggleModalEdit(items.entry_id, items.user_id)}}
                                                        >
                                                            <i className="fa fa-exclamation-triangle"></i>&nbsp;Reset Ujian
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

            </div>
        );
    }
}

export default Score;



// WEBPACK FOOTER //
// ./src/views/Exam/Pantau/Score.js